import React from 'react';
import PropTypes from 'prop-types';
import { ProminentLabel } from 'web-ui-components/lib/typography/labels';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const AccountPickerLauncher = ({
  onShowAccountPicker,
  mainLabelText,
  bodyText,
  buttonText,
}) => (
  <div className="web-ui-components">
    <div className="accountpicker__launcher">
      <ProminentLabel>{mainLabelText}</ProminentLabel>
      <StandardBody>{bodyText}</StandardBody>
      <Button display="primary" onClick={onShowAccountPicker}>
        {buttonText}
      </Button>
    </div>
  </div>
);

AccountPickerLauncher.propTypes = {
  onShowAccountPicker: PropTypes.func.isRequired,
  mainLabelText: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
};

export default AccountPickerLauncher;
